import { CommonModule } from '@angular/common';
import { Component, input, OnInit, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { AuthGuardService } from '@app/services/auth-guard.service';
import { EncryptionService } from '@app/services/encyption.service';
import { MediaService } from '@app/services/media.service';
import moment from 'moment';

@Component({
    selector: 'clever-bosyshotel',
    imports: [
        CommonModule,
        MatIconModule
    ],
    templateUrl: './bosyshotel.html',
    styleUrl: './bosyshotel.scss'
})
export class Bosyshotel implements OnInit {
    offers = input<any>(null);
    offerid = input<any>(null);
    myoffer = input<any>(null);
    currentrecid = input<number>(0);

    showitem = signal<boolean>(false);

    currentOffer = signal<any>(null);
    categoryAr = signal<number[]>([]);

    constructor(
        protected mediaService: MediaService,
        protected guardService: AuthGuardService,
        protected encservice: EncryptionService,
        protected router: Router
    ) { }

    ngOnInit(): void {
        for (let i = 0; i < this.offers()?.length; i++) {
            if (this.offers()[i].recid === this.currentrecid()) {
                this.currentOffer.set(this.offers()[i]);
                i = this.offers().length;
            }

        }

        this.categoryAr.set([]);
        if (this.currentOffer().category > 0) {
            const catg = this.currentOffer().category / 10;
            for (let i = 0; i < Math.floor(catg); i++) {
                this.categoryAr().push(1);
            }
            if (catg > Math.floor(catg)) {
                this.categoryAr().push(0.5);
            }
        }

        // console.log(this.currentOffer());
    }

    async gotobookingline() {
        const elm = document.getElementById('bosysbookingtemplate');
        if (elm) {
            elm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    async gotoOffer(offer) {
        const path = this.router.createUrlTree(['offers', this.offerid(), offer.recid]).toString();
        const link = document.createElement('a');
        link.href = path;
        link.setAttribute('visibility', 'hidden');
        link.click();

    }

    async openItem(ev) {
        ev.stopPropagation();
        this.showitem.set(!this.showitem());
    }

    async gotoUrl() {
        // console.log(this.myoffer()?.book_ibelink);
        const parsedUrl = new URL(this.myoffer()?.book_ibelink);
        const params = new URLSearchParams(parsedUrl.search);
        const paramObject = Object.fromEntries(params.entries());

        // console.log(paramObject);

        const tmp_real: ParamFilters = {
            provider: 'all',
            productSubType: paramObject['productSubType'],
            productType: paramObject['engine'],
            giataIdList: paramObject['giataIdList'],
            // giataIdList: '3082',
        } as ParamFilters;
        if (paramObject['adults']) {
            tmp_real.reisendeResult = {
                adults: paramObject['adults'],
                children: paramObject['children'] ? paramObject['children']?.split(',') : []
            };
        }
        if (paramObject['allowedTourOperatorList']) {
            tmp_real.tourOperatorList = [{
                name: '',
                code: paramObject['allowedTourOperatorList']
            }];
        }
        if (paramObject['boardTypeList']) {
            tmp_real.boardTypeList = [{
                name: '',
                code: paramObject['boardTypeList']
            }];
        }
        if (paramObject['departureAirportList']) {
            tmp_real.airportsResult = [{
                name: '',
                code: paramObject['departureAirportList']
            }];
        }
        if (paramObject['roomTypeList']) {
            tmp_real.roomTypeList = [{
                name: '',
                code: paramObject['roomTypeList']
            }];
        }
        if (paramObject['searchDate']) {
            const tmp = paramObject['searchDate']?.split(',');
            if (tmp?.length > 0) {
                tmp_real.reisezeitraumResult = {
                    start: moment(tmp[0], 'DDMMYY').format("YYYY-MM-DD"),
                    end: moment(tmp[1], 'DDMMYY').format("YYYY-MM-DD"),
                    minDuration: Number(tmp[2]),
                    maxDuration: Number(tmp[2]),
                };
            }
        }
        tmp_real.reference = 'uiOfficeID:' + this.offerid();
        const url = this.router.createUrlTree([this.guardService.getPartnerId(), 'ibeoffers'], { queryParams: { params: this.encservice.encrypt(tmp_real) } }).toString();
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.setAttribute('visibility', 'hidden');
        link.click();

        // this.tmp_real().giataIdList = this.giataId;
        // this.tmp_real().hotelCodeList = this.hotelCode;
        // if (this.hotel()?.name?.length > 0) {
        //     this.tmp_real().pauschalreiseResult = {
        //         data: {
        //             name: this.name(),
        //             code: this.giataId?.length > 1 ? this.giataId
        //                 : this.tourOperator + '_' + this.hotelCode
        //         },
        //         type: 1,
        //     }
        // }
    }

}
